import {
  createMatterIntakeTemplateV1,
  deleteMatterIntakeTemplateV1,
  updateMatterIntakeTemplateV1,
} from "@/lib/data/requests/matters/matter-intake-template";
import { queryKeys } from "@/lib/data/static/query-keys";
import type { APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-hot-toast";

export const useCreateMatterIntakeTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createMatterIntakeTemplateV1,
    onSuccess: () => {
      toast.success("Matter intake template created successfully");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error creating matter intake template");
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
  });
};

export const useUpdateMatterIntakeTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMatterIntakeTemplateV1,
    onSuccess: () => {
      toast.success("Matter intake template updated successfully");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error updating matter intake template");
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
  });
};

export const useDeleteMatterIntakeTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteMatterIntakeTemplateV1,
    onSuccess: () => {
      toast.success("Matter intake template deleted successfully");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error deleting matter intake template");
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
  });
};
